/**
 * Section Statistiques - Animation des chiffres
 * Les chiffres s'animent de 0 à la valeur finale quand la section devient visible
 */

(function() {
  'use strict';

  // ================================================
  // ANIMATION DES CHIFFRES
  // ================================================
  
  function animateNumber(element, target, duration = 2500) {
    const isPercentage = target.includes('%');
    const targetNumber = parseInt(target.replace(/[^0-9]/g, ''));
    
    if (isNaN(targetNumber)) return;
    
    const startTime = performance.now();
    const startValue = 0;
    
    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (ease-out)
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = Math.floor(startValue + (targetNumber - startValue) * easeProgress);
      
      // Afficher le chiffre avec ou sans %
      if (isPercentage) {
        element.textContent = currentValue + '%';
      } else {
        element.textContent = currentValue;
      }
      
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        // S'assurer d'afficher la valeur finale exacte
        element.textContent = target;
      }
    }
    
    requestAnimationFrame(update);
  }
  
  // ================================================
  // INTERSECTION OBSERVER
  // ================================================
  
  function initStatsAnimation() {
    const statsSection = document.querySelector('.stats-section');
    if (!statsSection) return;
    
    const statNumbers = statsSection.querySelectorAll('.stat-number');
    if (!statNumbers.length) return;
    
    // Sauvegarder les valeurs originales
    const originalValues = [];
    statNumbers.forEach(number => {
      originalValues.push(number.textContent);
    });
    
    // Observer pour détecter quand la section devient visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // La section est visible, animer les chiffres
          statNumbers.forEach((number, index) => {
            animateNumber(number, originalValues[index], 2500);
          });
          
          // Ne lancer l'animation qu'une seule fois
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.3 // Déclencher quand 30% de la section est visible
    });
    
    observer.observe(statsSection);
  }
  
  // ================================================
  // INITIALISATION
  // ================================================
  
  function init() {
    initStatsAnimation();
  }

  // Lancer au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Réinitialiser si besoin (ex: après AJAX Shopify)
  document.addEventListener('shopify:section:load', init);

})();